import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=11b19b05"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b19b05')) {
      api.createRecord('11b19b05', component.options)
    } else {
      api.reload('11b19b05', component.options)
    }
    module.hot.accept("./EventCard.vue?vue&type=template&id=11b19b05", function () {
      api.rerender('11b19b05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/EventCard.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/EventCard.vue
// module id = 370
// module chunks = 0